export enum DocumentoFacturaEnum {
    CUIT =  80,
    CUIL =  86,
    DNI =  96,
    CFINAL = 99
  }